import { React, useState, useEffect } from "react";
import {
  Box,
  Flex,
  IconButton,
  useColorMode,
  VStack,
  HStack,
  Text,
  Image,
  Progress,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiHome,
  FiGrid,
  FiHeart,
  FiList,
  FiSearch,
  FiSun,
  FiMoon,
  FiPlay,
  FiPause,
  FiSkipBack,
  FiSkipForward,
  FiLogOut,
} from "react-icons/fi";
import Cookies from "js-cookie";

import { useMusic } from "../context/MusicContext";

const MotionBox = motion(Box);

const Layout = ({ children }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const [showPlayerBar, setShowPlayerBar] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const {
    audioRef,
    currentTime,
    currentTrack,
    setCurrentTrack,
    setIsPlaying,
    isPlaying,
    playNext,
    playPrevious,
  } = useMusic();

  useEffect(() => {}, [currentTime]);

  useEffect(() => {
    if (currentTrack.url && currentTrack.page_url) {
      setShowPlayerBar(true);
    }
  }, [currentTrack.url]);

  const navItems = [
    { icon: FiHome, label: "خانه", path: "/" },
    { icon: FiGrid, label: "دسته‌بندی‌ها", path: "/categories" },
    { icon: FiHeart, label: "مورد علاقه", path: "/favorites" },
    // { icon: FiList, label: "پلی‌لیست‌ها", path: "/playlists" },
    { icon: FiSearch, label: "جستجو", path: "/search" },
  ];

  function LogOut(){
    Cookies.remove("User");
    navigate("/login");
  }

  return (
    <Flex h="100vh" direction="column">
      <Box flex="1" overflowY="auto" pb="100px">
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </MotionBox>
      </Box>

      {/* Player Bar */}
      {/* <Box
      onClick={() => navigate('/player')}
        position="fixed"
        bottom="60px"
        left="0"
        right="0"
        style={{
          backdropFilter: 'blur(10px)',
          backgroundColor: colorMode === 'dark' ? 'rgba(45, 55, 72, 0.8)' : 'rgba(255, 255, 255, 0.2)'
        }}
        border="1px solid"
        borderColor={colorMode === 'dark' ? 'gray.700' : 'gray.200'}
        p={4}
        borderRadius={15}
        m={2}
        boxShadow={`0 0 10px 0 ${colorMode !== 'dark' ? 'rgba(45, 55, 72, 0.8)' : 'rgba(255, 255, 255, 0.2)'}`}
      >
        <VStack spacing={2}>

          <HStack justify="space-between" w="100%">
            <HStack spacing={4}>
              <Image
                boxSize="40px"
                borderRadius="md"
                src={currentTrack.cover}
                alt="Album art"
              />
              <VStack align="start" spacing={0}>
                 <Text 
                  fontWeight="1px" 
                  cursor="pointer"
                  onClick={() => navigate('/player')}
                  _hover={{ color: 'brand.500' }}
                >
                 
                </Text>
                <Text fontSize="sm" color="whitesmoke">
                  {currentTrack.title}
                </Text>
              </VStack>
            </HStack>
            <HStack spacing={4}>
              <IconButton
                icon={<FiSkipBack />}
                variant="ghost"
                aria-label="Previous"
              />
              <IconButton
                icon={isPlaying ? <FiPause /> : <FiPlay />}
                colorScheme="brand"
                rounded="full"
                onClick={() => setIsPlaying(!isPlaying)}
                aria-label={isPlaying ? 'Pause' : 'Play'}
              />
              <IconButton
                icon={<FiSkipForward />}
                variant="ghost"
                aria-label="Next"
              />
            </HStack>
          </HStack>
        </VStack>
      </Box> */}

      <AnimatePresence>
        {showPlayerBar && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.3 }}
            style={{
              position: "fixed",
              bottom: "60px",
              left: 0,
              right: 0,
              zIndex: 1000,
            }}
          >
            <Box
              style={{
                backgroundImage: `linear-gradient(to right, ${
                  colorMode === "dark"
                    ? "rgba(255, 255, 255, 0.07)"
                    : "rgba(0, 0, 0, 0.13)"
                }  ${
                  (currentTime / audioRef.current.duration) * 100
                }%, transparent ${
                  (currentTime / audioRef.current.duration) * 100
                }%)`,
                backdropFilter: "blur(10px)",
                backgroundColor:
                  colorMode === "dark"
                    ? "rgba(45, 55, 72, 0.8)"
                    : "rgba(255, 255, 255, 0.2)",
              }}
              border="1px solid"
              borderColor={colorMode === "dark" ? "gray.700" : "gray.200"}
              p={4}
              borderRadius={15}
              m={2}
              boxShadow={`0 0 10px 0 ${
                colorMode !== "dark"
                  ? "rgba(45, 55, 72, 0.8)"
                  : "rgba(255, 255, 255, 0.2)"
              }`}
            >
              <VStack spacing={2}>
                <HStack justify="space-between" w="100%">
                  <HStack spacing={4} onClick={() => navigate("/player")}>
                    <Image
                      boxSize="40px"
                      borderRadius="md"
                      src={currentTrack.cover}
                      alt="Album art"
                    />
                    <VStack align="start" spacing={0}>
                      <Text
                        fontSize="sm"
                        color={colorMode === "dark" ? "whitesmoke" : "black"}
                      >
                        {currentTrack.title}
                      </Text>
                    </VStack>
                  </HStack>
                  <HStack spacing={4}>
                    <IconButton
                      icon={<FiSkipBack />}
                      variant="ghost"
                      aria-label="Previous"
                      onClick={() => playNext()}
                    />
                    <IconButton
                      icon={isPlaying ? <FiPause /> : <FiPlay />}
                      colorScheme="brand"
                      rounded="full"
                      onClick={() => setIsPlaying(!isPlaying)}
                      aria-label={isPlaying ? "Pause" : "Play"}
                    />
                    <IconButton
                      icon={<FiSkipForward />}
                      variant="ghost"
                      aria-label="Next"
                      onClick={() => playPrevious()}
                    />
                  </HStack>
                </HStack>
              </VStack>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Navigation Bar */}
      <Box
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        style={{
          backdropFilter: "blur(10px)",
          backgroundColor:
            colorMode === "dark"
              ? "rgba(45, 55, 72, 0.8)"
              : "rgba(255, 255, 255, 0.8)",
        }}
        borderTop="1px"
        borderColor={colorMode === "dark" ? "gray.700" : "gray.200"}
        p={2}
      >
        <HStack justify="space-around">
          {navItems.map((item) => (
            <Link key={item.path} to={item.path}>
              <VStack spacing={1}>
                <IconButton
                  icon={<item.icon />}
                  variant={location.pathname === item.path ? "solid" : "ghost"}
                  colorScheme={
                    location.pathname === item.path ? "brand" : "gray"
                  }
                  aria-label={item.label}
                />
                {/* <Text fontSize="xs">{item.label}</Text> */}
              </VStack>
            </Link>
          ))}
          <IconButton
            icon={colorMode === "dark" ? <FiSun /> : <FiMoon />}
            onClick={toggleColorMode}
            variant="ghost"
            aria-label="Toggle color mode"
          />
          <IconButton
            icon={ <FiLogOut /> }
            onClick={LogOut}
            variant="ghost"
            aria-label="Toggle color mode"
          />
        </HStack>
      </Box>
    </Flex>
  );
};

export default Layout;
